import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { createSelector } from 'reselect';
import { createSelector as createRecomputeSelector } from '@jvitela/recompute';
import { isMatch as _isMatch, isEmpty as _isEmpty } from 'lodash';
import common from '../../_common/selectors';
import commonHelpers from '../../_common/helpers';
import mapsSelectors from '../../Maps/selectors';
import dataSpatialRelationsSelectors from '../../Data/SpatialRelations/selectors';
/**
 * Creates standartizet controlled map layer definition object.
 * @param {Object} timelineLayerState Map Layer definition that corresponds with deffinition for map
 * @param {string} timelineLayerOriginPeriodKey optional periodKey
 * @param {Object} activeKeys optional active app keys
 */

var getTimelineMapLayerPeriodDefinition = createSelector([function (timelineLayerState) {
  return timelineLayerState;
}, function (timelineLayerState, timelineLayerOriginPeriodKey) {
  return timelineLayerOriginPeriodKey;
}, function (timelineLayerState, timelineLayerOriginPeriodKey, activeKeys) {
  return activeKeys;
}], function (timelineLayerState, timelineLayerOriginPeriodKey) {
  var activeKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var timelineMapLayerDefinition = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, timelineLayerState !== null && timelineLayerState !== void 0 && timelineLayerState.key ? {
    key: timelineLayerState.key
  } : {}), timelineLayerState !== null && timelineLayerState !== void 0 && timelineLayerState.layerKey ? {
    layerKey: timelineLayerState.layerKey
  } : {}), timelineLayerOriginPeriodKey || timelineLayerState !== null && timelineLayerState !== void 0 && timelineLayerState.metadataModifiers ? {
    metadataModifiers: commonHelpers.mergeFilters(activeKeys, timelineLayerState.filterByActive || {}, _objectSpread({}, timelineLayerState !== null && timelineLayerState !== void 0 && timelineLayerState.metadataModifiers ? timelineLayerState.metadataModifiers : {}))
  } : {}), timelineLayerState !== null && timelineLayerState !== void 0 && timelineLayerState.layerTemplateKey ? {
    layerTemplateKey: timelineLayerState.layerTemplateKey
  } : {}), timelineLayerState !== null && timelineLayerState !== void 0 && timelineLayerState.styleKey ? {
    styleKey: timelineLayerState.styleKey
  } : {});

  if (_isEmpty(timelineMapLayerDefinition.metadataModifiers)) {
    timelineMapLayerDefinition.metadataModifiers = {};
  } // put original period to metadataModifiers


  if (timelineLayerOriginPeriodKey) {
    timelineMapLayerDefinition.metadataModifiers.periodKey = timelineLayerOriginPeriodKey;
  }

  if (_isEmpty(timelineMapLayerDefinition.metadataModifiers)) {
    delete timelineMapLayerDefinition.metadataModifiers;
  }

  return timelineMapLayerDefinition;
});
/**
 * Find corresponding map layer by timeline layer definition.
 * @param {string} mapKey
 * @param {Object} timelineLayer
 * @param {Object} timelineLayerPeriodItem
 * @returns {Object|null} Map layer definition if any exists in map
 */

var getMapLayerByTimelineLayerAndPeriod = createRecomputeSelector(function (mapKey, timelineLayer, timelineLayerPeriodItem) {
  if (mapKey && timelineLayer && timelineLayerPeriodItem) {
    var activeKeys = common.getAllActiveKeysObserver();
    var mapLayers = mapsSelectors.getLayersStateWithMergedFiltersByMapKeyObserver(mapKey);
    var timelineMapLayerDefinition = getTimelineMapLayerPeriodDefinition(timelineLayer === null || timelineLayer === void 0 ? void 0 : timelineLayer.layerState, timelineLayerPeriodItem === null || timelineLayerPeriodItem === void 0 ? void 0 : timelineLayerPeriodItem.key, activeKeys);
    var mapLayer = mapLayers === null || mapLayers === void 0 ? void 0 : mapLayers.find(function (l) {
      return _isMatch(l, timelineMapLayerDefinition);
    });
    return mapLayer;
  } else {
    return null;
  }
});
/**
 * Find corresponding map layer by timeline layer definition. If layer does not exists, return false, else return true.
 * @param {string} mapKey
 * @param {Object} timelineLayer
 * @param {Object} timelineLayerPeriodItem
 * @returns {Boolean} Whether layer exists in map
 */

var getTimelineLayerPeriodActive = createRecomputeSelector(function (mapKey, timelineLayer, timelineLayerPeriodItem) {
  var mapLayer = getMapLayerByTimelineLayerAndPeriod(mapKey, timelineLayer, timelineLayerPeriodItem);
  return !!mapLayer;
});
var getPeriodKeysForFilteredSpatialRelations = createSelector([dataSpatialRelationsSelectors.getIndexed], function (spatialRelationsIndex) {
  if (!_isEmpty(spatialRelationsIndex)) {
    var periodKeysFromRelations = spatialRelationsIndex === null || spatialRelationsIndex === void 0 ? void 0 : spatialRelationsIndex.map(function (r) {
      var _r$data;

      return r === null || r === void 0 ? void 0 : (_r$data = r.data) === null || _r$data === void 0 ? void 0 : _r$data.periodKey;
    }).filter(function (a) {
      return a;
    });
    return periodKeysFromRelations;
  } else {
    return null;
  }
});
export default {
  getTimelineLayerPeriodActive: getTimelineLayerPeriodActive,
  getTimelineMapLayerPeriodDefinition: getTimelineMapLayerPeriodDefinition,
  getMapLayerByTimelineLayerAndPeriod: getMapLayerByTimelineLayerAndPeriod,
  getPeriodKeysForFilteredSpatialRelations: getPeriodKeysForFilteredSpatialRelations
};